module.exports = __webpack_public_path__ + "img/Chatapp1.b63c3d26.jpg";